import { render } from "./pie.vue?vue&type=template&id=b3d0b5a6&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"

import "./pie.vue?vue&type=style&index=0&id=b3d0b5a6&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-b3d0b5a6"

export default script